<template>
	<div class="footer" v-if="!!paging && !!pagingInfo">
		<div v-if="!!pagingInfo" class="pagination-info">
			<span class="info-text">
				<span class="from">{{ min }}</span> - <span class="to">{{ max }}</span> di
				<span class="total">{{ itemsCount }}</span> risultati</span
			>
		</div>
		<ul class="pagination">
			<datatable-pagination-item
				v-if="!!showFirstLast"
				:icon="['far', 'angle-double-left']"
				label="Inizio"
				:disabled="!!isFirstPage() ? true : false"
				:page="1"
				classType="first"
			></datatable-pagination-item>

			<datatable-pagination-item
				:icon="['far', 'angle-left']"
				label="Precedente"
				:disabled="!!isFirstPage() ? true : false"
				:page="getPrev()"
				classType="prev"
			></datatable-pagination-item>

			<datatable-pagination-item
				v-for="(item, index) in range"
				:text="item"
				:key="index"
				:active="!!isItemActive(item) ? true : false"
				:page="item"
			></datatable-pagination-item>

			<datatable-pagination-item
				:icon="['far', 'angle-right']"
				label="Successiva"
				:disabled="!!isLastPage() ? true : false"
				:page="getNext()"
				classType="next"
			></datatable-pagination-item>

			<datatable-pagination-item
				v-if="!!showFirstLast"
				:icon="['far', 'angle-double-right']"
				label="Fine"
				:disabled="!!isLastPage() ? true : false"
				:page="total"
				classType="last"
			></datatable-pagination-item>
		</ul>
	</div>
</template>

<script>
import _ from 'lodash'
export default {
	data: () => ({
		pageRange: 5,
		showFirstLast: true,
		range: [],
		min: 1,
		max: 1,
	}),
	props: {
		paging: {
			type: Boolean,
			default: true,
			required: false,
		},
		pagingInfo: {
			type: Boolean,
			default: true,
			required: false,
		},
		length: {
			type: Number,
			default: 1,
			required: true,
		},
		itemsCount: {
			type: Number,
			default: 1,
			required: true,
		},
		total: {
			type: Number,
			default: 1,
			required: true,
		},
		current: {
			type: Number,
			default: 1,
			required: true,
		},
	},
	computed: {},
	methods: {
		isItemActive: function(item) {
			return this.current == item
		},
		isFirstPage: function() {
			return this.current <= 1
		},
		isLastPage: function() {
			return this.current >= this.total
		},
		getFirstOfRange: function(num) {
			if (num % this.pageRange == 1) return num
			else return this.getFirstOfRange(num - 1)
		},
		setRange: function() {
			let start = this.getFirstOfRange(this.current)
			if (start < 1) start = 1

			let end = start + this.pageRange
			if (end > this.total) end = this.total + 1

			let range = _.range(start, end)
			if (!range.length) range = [1]

			this.range = range
		},
		getPrev: function() {
			if (this.current < 1) return 1
			else return this.current - 1
		},
		getNext: function() {
			if (this.current > this.total) return this.total
			else return this.current + 1
		},
		toPage: function(page) {
			return this.$parent.changePage(page)
		},
		first: function() {
			return this.toPage(1)
		},
		last: function() {
			return this.toPage(this.total)
		},
		prev: function() {
			return this.toPage(this.getPrev())
		},
		next: function() {
			return this.toPage(this.getNext())
		},
		setMinMax: function() {
			if (!this.itemsCount) {
				this.min = 0
				this.max = 0
			} else {
				this.min = (this.current - 1) * this.length + 1
				this.max = this.current * this.length

				if (this.max > this.itemsCount) this.max = this.itemsCount
			}
		},
	},
	created: function() {
		this.setMinMax()
		this.setRange()
	},
	beforeUpdate: function() {
		this.setMinMax()
		this.setRange()
	},
}
</script>
